module.exports = __webpack_public_path__ + "img/logo.fba8466b.png";